import { createSelector } from "reselect";
import * as ChapterType from "utils/ChapterType";
import getAdPlaying from "selectors/ads/getAdPlaying";
import getActiveChapterEntity from "selectors/chapter/getActiveChapterEntity";

const getDisableContain = (state, ownProps = {}) => !!ownProps.disableContain;
const getFitMode = (state) =>
  state.playerOptions && state.playerOptions.fitMode;

export default createSelector(
  [getActiveChapterEntity, getAdPlaying, getDisableContain, getFitMode],
  (activeChapterEntity, adPlaying, disableContain, fitMode) => {
    if (adPlaying) return true;
    if (disableContain) return false;

    if (
      activeChapterEntity &&
      (activeChapterEntity.type === ChapterType.PATHFINDER ||
        activeChapterEntity.type === ChapterType.VIDEO)
    ) {
      if (fitMode && fitMode === "fill") return false;
      if (fitMode && fitMode === "fit") return true;
    }

    return !!disableContain;
  },
);
